Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _airbnbWithTracking = require('airbnb-with-tracking');

var _airbnbWithTracking2 = _interopRequireDefault(_airbnbWithTracking);

var _DOMButtonOrA = require('../private/DOMButtonOrA');

var _DOMButtonOrA2 = _interopRequireDefault(_DOMButtonOrA);

var _Loader = require('./Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _iconProp = require('../utils/propTypes/iconProp');

var _iconProp2 = _interopRequireDefault(_iconProp);

var _href = require('../utils/propTypes/href');

var _href2 = _interopRequireDefault(_href);

var _textAlignPosition = require('../constants/textAlignPosition');

var _textAlignPosition2 = _interopRequireDefault(_textAlignPosition);

var _Airmoji = require('./Airmoji');

var _Airmoji2 = _interopRequireDefault(_Airmoji);

var _Labeled = require('./Labeled');

var _Labeled2 = _interopRequireDefault(_Labeled);

var _withStyles = require('../themes/withStyles');

var _withBrand = require('../themes/withBrand');

var _withBrand2 = _interopRequireDefault(_withBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var flagValidator = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('navigation', 'footer', 'mono');

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {

  brand: _withBrand.requiredBrandPropType,
  children: (0, _airbnbPropTypes.or)([_textlike2['default'], (0, _airbnbPropTypes.childrenOfType)(_Airmoji2['default'])]),
  href: _href2['default'],
  submit: (0, _airbnbPropTypes.or)([_propTypes2['default'].oneOf([false]), (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes2['default'].bool, 'href', 'submit')]),
  onPress: _propTypes2['default'].func,
  beforeIcon: _iconProp2['default'],
  afterIcon: _iconProp2['default'],
  openInNewWindow: _propTypes2['default'].bool,
  navigation: flagValidator,
  footer: flagValidator,
  mono: flagValidator,
  loading: _propTypes2['default'].bool,
  textAlign: _textAlignPosition.textAlignPositionProp,
  itemPropSameAs: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  isExpander: _propTypes2['default'].bool,
  expanded: _propTypes2['default'].bool,
  ariaControls: _idProp2['default'],
  ariaHasPopup: _propTypes2['default'].bool,
  linkRef: _propTypes2['default'].func,
  ampVarsClickType: _propTypes2['default'].string,
  ampReplace: _propTypes2['default'].string,
  velouteId: _propTypes2['default'].string,
  inlineBlockWithIcon: _propTypes2['default'].bool,
  inverse: _propTypes2['default'].bool,
  noWrap: _propTypes2['default'].bool
}));

var defaultProps = {
  onPress: function () {
    function onPress() {}

    return onPress;
  }(),

  openInNewWindow: false,
  navigation: false,
  footer: false,
  mono: false,
  loading: false,
  textAlign: _textAlignPosition2['default'].START,
  itemPropSameAs: false,
  submit: false,
  disabled: false,
  isExpander: false,
  expanded: false,
  ariaControls: undefined,
  ariaHasPopup: false,
  ampVarsClickType: undefined,
  ampReplace: undefined,
  linkRef: function () {
    function linkRef() {}

    return linkRef;
  }(),

  velouteId: undefined,
  inlineBlockWithIcon: false,
  inverse: false,
  noWrap: false
};

function Link(_ref) {
  var css = _ref.css,
      brand = _ref.brand,
      children = _ref.children,
      href = _ref.href,
      onPress = _ref.onPress,
      beforeIcon = _ref.beforeIcon,
      afterIcon = _ref.afterIcon,
      openInNewWindow = _ref.openInNewWindow,
      navigation = _ref.navigation,
      footer = _ref.footer,
      mono = _ref.mono,
      loading = _ref.loading,
      textAlign = _ref.textAlign,
      itemPropSameAs = _ref.itemPropSameAs,
      submit = _ref.submit,
      disabled = _ref.disabled,
      isExpander = _ref.isExpander,
      expanded = _ref.expanded,
      ariaControls = _ref.ariaControls,
      ariaHasPopup = _ref.ariaHasPopup,
      styles = _ref.styles,
      ampVarsClickType = _ref.ampVarsClickType,
      ampReplace = _ref.ampReplace,
      linkRef = _ref.linkRef,
      velouteId = _ref.velouteId,
      inlineBlockWithIcon = _ref.inlineBlockWithIcon,
      inverse = _ref.inverse,
      noWrap = _ref.noWrap;

  if (loading) {
    return _react2['default'].createElement(
      'div',
      css(styles.loader),
      _react2['default'].createElement(_Loader2['default'], { inline: true })
    );
  }

  var inner = void 0;

  if (beforeIcon) {
    inner = _react2['default'].createElement(
      _Labeled2['default'],
      {
        before: beforeIcon
      },
      children
    );
  } else if (afterIcon) {
    inner = _react2['default'].createElement(
      _Labeled2['default'],
      {
        after: afterIcon
      },
      children
    );
  } else {
    inner = children;
  }

  // Note: only DOMButtonOrA should be aware of what component is actually going to render,
  // but because default styling for buttons and links are so different, we only want to reset
  // the button styles if it's actually a button.
  var isButton = !href || disabled;

  // When the Link is not an expander, we want aria-expanded to be undefined regardless of the
  // value of the expanded prop, because it is irrelevant in that case.
  // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
  var ariaExpanded = isExpander ? expanded : undefined;

  var isSelectBrand = brand === _withBrand.BRAND_SELECT;
  var isLuxuryBrand = brand === _withBrand.BRAND_LUXURY;

  var inlineBlock = inlineBlockWithIcon && (!!beforeIcon || !!afterIcon);

  return _react2['default'].createElement(
    _DOMButtonOrA2['default'],
    _extends({
      href: href,
      onClick: function () {
        function onClick(e) {
          if (disabled) {
            e.preventDefault();
          } else {
            onPress(e);
          }
        }

        return onClick;
      }(),
      openInNewWindow: openInNewWindow,
      itemProp: itemPropSameAs ? 'sameAs' : null,
      type: submit ? _DOMButtonOrA.buttonTypes.submit : _DOMButtonOrA.buttonTypes.button,
      disabled: disabled,

      ariaControls: ariaControls,
      ariaDisabled: disabled,
      ariaExpanded: ariaExpanded,
      ariaHasPopup: ariaHasPopup,
      removeOutlineOnPress: true,
      ampVarsClickType: ampVarsClickType,
      ampReplace: ampReplace,
      buttonAnchorRef: linkRef,
      velouteId: velouteId
    }, css(styles.component, styles.component_interactions, isButton && styles.component_button, textAlign === _textAlignPosition2['default'].CENTER && styles.button_center_align, textAlign === _textAlignPosition2['default'].START && styles.button_start_align, textAlign === _textAlignPosition2['default'].END && styles.button_end_align, textAlign === _textAlignPosition2['default'].JUSTIFY && styles.button_justify_align, isSelectBrand && styles.color_select, isLuxuryBrand && !navigation && styles.component_luxury, disabled && styles.component_disabled, navigation && styles.navigation, inverse && styles.color_inverse, footer && styles.footer, mono && styles.mono, inlineBlock && styles.component_inlineBlock, noWrap && styles.component_noWrap)),
    inner
  );
}

Link.componentCategory = 'Core';
Link.displayName = 'Link';
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

exports['default'] = (0, _airbnbWithTracking2['default'])('Link', ['onPress'])((0, _withBrand2['default'])((0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color,
      font = _ref2.font,
      unit = _ref2.unit;
  return {
    color_select: {
      color: color.core.hackberry,
      ':active': {
        color: color.buttons.selectActiveColor
      },
      ':hover': {
        color: color.core.hackberry
      }
    },

    color_inverse: {
      color: color.white,

      ':hover': {
        color: color.textLinkInverseHover
      },

      ':active': {
        color: color.textLinkInverseActive
      }
    },

    component: {
      color: color.textLink,
      font: 'inherit',
      fontFamily: font.FONT_FAMILY, // TODO remove this
      textDecoration: 'none'
    },

    component_noWrap: {
      whiteSpace: 'nowrap'
    },

    component_interactions: {
      ':hover': {
        textDecoration: 'underline',
        color: color.textLinkHover
      },

      ':focus': {
        textDecoration: 'underline'
      },

      ':active': {
        color: color.textLinkActive
      }
    },

    component_button: {
      appearance: 'none',
      background: 'transparent',
      border: 0,
      cursor: 'pointer',
      margin: 0,
      padding: 0,
      userSelect: 'auto',

      ':active': {
        // Remove focus ring while clicking, but not when keyboard tabbing around.
        outline: 0
      }
    },

    component_luxury: {
      textDecoration: 'underline'
    },

    button_center_align: {
      textAlign: 'center'
    },

    button_start_align: {
      textAlign: 'left'
    },

    button_end_align: {
      textAlign: 'right'
    },

    button_justify_align: {
      textAlign: 'justify'
    },

    component_disabled: {
      color: color.textMuted,
      cursor: 'default',

      ':hover': {
        color: color.textMuted,
        textDecoration: 'none'
      },

      ':active': {
        color: color.textMuted
      }
    },

    component_inlineBlock: {
      display: 'inline-block'
    },

    navigation: {
      color: color.textLinkNavigation,
      ':hover': {
        color: color.textLinkNavigationHover
      }
    },

    footer: {
      color: color.textMuted,
      ':hover': {
        color: color.textMuted
      }
    },

    mono: {
      color: color.core.hof,
      ':hover': {
        color: color.core.hof
      },
      textDecoration: 'underline'
    },

    loader: {
      display: 'inline',
      marginLeft: unit,
      marginRight: unit
    }
  };
}, { pureComponent: true })(Link)));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Link.js
// module id = 74
// module chunks = 168707334958949